import * as React from 'react';

function SvgShield(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
      <path d="M11.649 1.064l-8 3A1 1 0 003 5v7c0 2.97 1.646 5.644 4.341 8.003a22.465 22.465 0 002.879 2.126l.547.332.449.256.337.177a1 1 0 00.894 0l.337-.177.45-.256.354-.213.192-.119c.98-.612 1.96-1.323 2.879-2.126C19.354 17.643 21 14.969 21 12V5a1 1 0 00-.649-.936l-8-3a1 1 0 00-.702 0zM12 3.069l7 2.625V12c0 2.28-1.354 4.481-3.659 6.497a20.49 20.49 0 01-2.621 1.936l-.45.274-.27.155-.27-.155-.45-.274a20.49 20.49 0 01-2.621-1.936l-.262-.233C6.252 16.312 5 14.193 5 12V5.694l7-2.625z" />
    </svg>
  );
}

export default SvgShield;
